var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlipBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.69 216c6.23 6.24 16.39 6.24 22.62 0L136 195.31c6.24-6.23 6.24-16.39 0-22.62L115.31 152H400c26.47 0 48 21.53 48 48 0 13.23 10.77 24 24 24h16c13.23 0 24-10.77 24-24 0-61.76-50.24-112-112-112H115.31L136 67.31c6.24-6.23 6.24-16.39 0-22.62L115.31 24c-6.23-6.24-16.39-6.24-22.62 0L2.34 114.34a8.015 8.015 0 0 0 0 11.32zM419.31 296c-6.23-6.24-16.38-6.24-22.62 0L376 316.69c-6.252 6.252-6.262 16.358 0 22.62L396.69 360H112c-26.47 0-48-21.53-48-48 0-13.23-10.77-24-24-24H24c-13.23 0-24 10.77-24 24 0 61.76 50.24 112 112 112h284.69L376 444.69c-6.252 6.252-6.262 16.358 0 22.62L396.69 488c6.241 6.241 16.38 6.24 22.62 0l90.35-90.34a8.015 8.015 0 0 0 0-11.32z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipBoard);
export default __webpack_public_path__ + "static/media/Flip-Board.e51f88ef58c54feb1ade9e8319fe5798.svg";
export { ForwardRef as ReactComponent };